import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { CustomRadioComponent } from './components/custom-radio/custom-radio.component';

import { DropdownInputComponent } from './components/dropdown-input/dropdown-input.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { HeaderNavComponent } from './components/header-nav/header-nav.component';
import { HelpBarComponent } from './components/help-bar/help-bar.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { LangTogglerComponent } from './components/lang-toggler/lang-toggler.component';
import { LoanInfoCardComponent } from './components/UNUSED - loan-info-card/loan-card.-info.component';
import { OptInputComponent } from './components/opt-input/opt-input.component';
import { PasscodeInputComponent } from './components/passcode-input/passcode-input.component';
import { ToastComponent } from './components/toast/toast.component';

import { FilterPipe } from './pipes/filter.pipe';

import { CheckpointChainComponent } from './components/checkpoint-chain/checkpoint-chain.component';
import { CurrencyInputComponent } from './components/currency-input/currency-input.component';

import { PasswordInputComponent } from './components/password-input/password-input.component';

import { GridSearchComponent } from './components/grid-search/grid-search.component';
import { HorizontalScrollerComponent } from './components/horizontal-scroller/horizontal-scroller.component';
import { ProgressStepComponent } from './components/progress-step/progress-step.component';

import { CustomModalComponent } from './components/custom-modal/custom-modal.component';

import { CreditCardComponent } from './components/credit-card/credit-card.component';

import { RotarySelectorComponent } from './components/rotary-selector/rotary-selector.component';
import { SelectableContentComponent } from './components/selectable-content/selectable-content.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { DetectFocusDirective } from './directives/focus.directive';
import { LoanAmountModifierComponent } from './loan-amount-modifier/loan-amount-modifier.component';
import { LogoComponent } from './logo/logo.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { DateFilterPipe } from './pipes/date-filter.pipe';
import { IbanPipe } from './pipes/iban-formate.pipe';
import { ToNumberPipe } from './pipes/toNumber.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { ValueSplitterPipe } from './pipes/value-splitter.pipe';
import { SelectableListContentComponent } from './selectable-list-content/selectable-list-content.component';
import { SelectablePillComponent } from './selectable-pill/selectable-pill.component';
import { TenureModifierComponent } from './tenure-modifier/tenure-modifier.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ProductMarketingCardComponent } from './components/product-marketing-card/product-marketing-card.component';
import { environment } from 'src/environments/environment';
import { TracingService } from '../Core/services/tracing.service';
import { TrimDirective } from './directives/trimInput.directive';
import { AlertBarComponent } from './components/alert-bar/alert-bar.component';
import { SuccessPopupComponent } from './components/success-popup/success-popup.component';
import { InstallmentOptionsComponent } from './components/installment-options/installment-options.component';
import { ModifyAmountComponent } from './components/modify-amount/modify-amount.component';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, '../assets/i18n/shared/', '.json?v=' + environment.version);
}
export function getInitialLang(): string {
  return localStorage.getItem('lang') || 'ar';
}
@NgModule({
  declarations: [
    HeaderNavComponent,
    ToastComponent,
    PasscodeInputComponent,
    OptInputComponent,
    CustomRadioComponent,
    DropdownInputComponent,
    FilterPipe,
    LoanInfoCardComponent,
    InstructionsComponent,
    FileUploadComponent,
    HelpBarComponent,
    LangTogglerComponent,
    CurrencyInputComponent,
    CheckpointChainComponent,
    NotFoundComponent,
    TruncatePipe,
    ProductMarketingCardComponent,
    PasswordInputComponent,
    HorizontalScrollerComponent,
    CreditCardComponent,
    ProgressStepComponent,
    GridSearchComponent,
    DateFilterPipe,
    CurrencyFormatPipe,
    TenureModifierComponent,
    LoanAmountModifierComponent,
    CustomModalComponent,
    SelectableContentComponent,
    ValueSplitterPipe,
    IbanPipe,
    TooltipComponent,
    SelectablePillComponent,
    RotarySelectorComponent,
    SelectableListContentComponent,
    DetectFocusDirective,
    ToNumberPipe,
    LogoComponent,
    TrimDirective,
    SuccessPopupComponent,
    AlertBarComponent,
    InstallmentOptionsComponent,
    ModifyAmountComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: getInitialLang(),
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    HeaderNavComponent,
    ToastComponent,
    PasscodeInputComponent,
    OptInputComponent,
    CustomRadioComponent,
    DropdownInputComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    LoanInfoCardComponent,
    InstructionsComponent,
    FileUploadComponent,
    HelpBarComponent,
    LangTogglerComponent,
    CurrencyInputComponent,
    CheckpointChainComponent,
    TruncatePipe,
    PasswordInputComponent,
    HorizontalScrollerComponent,
    ProgressStepComponent,
    ProductMarketingCardComponent,
    CreditCardComponent,
    GridSearchComponent,
    FilterPipe,
    DateFilterPipe,
    CurrencyFormatPipe,
    TenureModifierComponent,
    LoanAmountModifierComponent,
    CustomModalComponent,
    SelectableContentComponent,
    ValueSplitterPipe,
    IbanPipe,
    TooltipComponent,
    SelectablePillComponent,
    RotarySelectorComponent,
    SelectableListContentComponent,
    DetectFocusDirective,
    ToNumberPipe,
    LogoComponent,
    TrimDirective,
    SuccessPopupComponent,
    AlertBarComponent,
    InstallmentOptionsComponent,
    ModifyAmountComponent
  ],
  providers: [IbanPipe],
})

export class SharedModule {
  constructor(tracingService: TracingService) {
    tracingService.traceEvent(`Shared Module: ${localStorage.getItem('lang')}`);
  }
}
